import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { FaStar } from "react-icons/fa";
import { motion } from "framer-motion";
import "./GoogleReview.css";

function GoogleReviews() {

  const googleReviewLink = "https://maps.app.goo.gl/VgHd2SXnwt8Uq4Jr5";

  const reviews = [
    { name: "Dr. Shraddha Mane", date: "12-01-2026", rating: 5, text: "It gives me great pleasure to express my satisfaction with the exceptional services at this clinic. The medical team is highly supportive and demonstrates profound expertise in skin and hair treatments. I would certainly recommend this clinic for those looking for quality aesthetic care." },
    { name: "Snehal Jori", date: "09-09-2025", rating: 5, text: "I had very nice experience with doctor trupti and satisfied with My skin treatment which . I'm very glad to say , me is very happy for getting satisfactory result within two visits of clinic. I have also observed that the doctor is very conscious & to understand skin issues very carefully while explaining to me.I'd like to tell you & recommend this clinic for the best skin treatment." },
    { name: "Ganesh Shinde", date: "15-09-2025", rating: 4, text: "I would like to sincerely thank you to Dr. Trupti Mam for the skin brightening  and acne treatment. I am very happy with the quick and visible results. My skin tone looks noticeably brighter and healthier in a short period, also get quick result for acne which has exceeded my expectations. I truly appreciate your guidance, expertise, and the care taken during the treatment. I will suggest must visit and do treatment those have issue and need honest result ." },
    { name: "Radha Narayan", date: "15-09-2025", rating: 4, text: "Awesome clinic with all asthetiscs procedure, and good care provided by doctor.....I did carban laser facial for skin brightening, and obtain a best result.....thanks dr. Trupti....must visit" }, 
    { name: "Nilam Jadhav", date: "08-11-2025", rating: 4, text: "I hv concern for hair fall, skin problem all things last 3years and I try many medicine and treatment but not get any results one of my friend suggest Dr. Trupti's Health&Beauty Clinic pimpari chinchvad. I came hear  for my hair fall, skin treatment and now I get results and satisfied with their service Thanku  Dr. Trupti's health& beauty clinic." }, 
    { name: "Aryan Solanke", date: "05-09-2025", rating: 5, text: "Dr. Trupti's clinic was good. I went for facial rejuvenation. Doctor checked my skin properly and gave me a special treatment. She told me about good skincare products. I liked my experience there. My skin looks fresher now." }, 
    { name: "Keshav Kadam", date: "12-09-2025", rating: 5, text: "I consulted Dr. Trupti shinde/hambire for my acne and dark spots. The doctor explained everything very clearly and suggested the right treatment. I have been taking the treatment since 3 months and I could see visible improvement into my skin. The clinic is well-maintained and Dr is very polite." }, 
    { name: "Sonali Chavan", date: "12-09-2025", rating: 4, text: "Good result for my hair treatment.Nice nature of madam and the way she deal with patient is very good.Very good and proper consultation from madam.Happy with treatment. Thank you mam. I recommend this clinic for the hair and skin treatment." }, 
    { name: "Snehal Bhosale", date: "05-09-2025", rating: 4, text: "I did hydra facial from Doctor Trupti. It was very amazing experience. The treatment was highly effective👌 Doctor Trupti is very friendly and gave me some extra tips too for my skin care 🙂 Must visit to the Dr. Trupti's clinic 😊" },
  ];

  return (
    <section className="py-5" style={{ backgroundColor: "#faf6f2" }}>
      <Container>

        {/* Heading */}
        <motion.div
          className="text-center mb-4"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <span className="hero-speacial text-uppercase">
            <strong>Testimonials</strong>
          </span>

          <h2 className="fw-bold pt-3">
            HEAR FROM OUR SATISFIED PATIENTS
          </h2>

          <div className="my-3">
            <span style={{ fontSize: "2rem", color: "#f4c542" }}>😊</span>
          </div>
        </motion.div>

        <Row>

          {/* Google Rating Section */}
          <Col md={4} className="mb-4">

            <motion.div
              className="p-4 shadow rounded bg-white text-center h-100"
              initial={{ opacity: 0, x: -80 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >

              <img
                src="https://upload.wikimedia.org/wikipedia/commons/2/2f/Google_2015_logo.svg"
                alt="Google"
                style={{ width: "120px", marginBottom: "15px" }}
              />

              <h5 className="fw-bold">Average Rating</h5>

              <h1 className="fw-bold display-4">4.9</h1>

              <div className="mb-2">
                {[...Array(5)].map((_, i) => (
                  <FaStar key={i} color="#f4c542" size={20} />
                ))}
              </div>

              <p className="text-muted">Based on 93 Reviews</p>

              <a
                href={googleReviewLink}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-dark mt-2"
              >
                Write Review
              </a>

            </motion.div>

          </Col>


          {/* Reviews Scroll Section */}
          <Col md={8}>

            <motion.div
              className="p-3 rounded custom-scrollbar"
              style={{ maxHeight: "500px", overflowY: "auto" }}
              initial={{ opacity: 0, x: 80 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >

              {reviews.map((review, idx) => (

                <motion.div
                  key={idx}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: idx * 0.1 }}
                >

                  <Card className="mb-3 review-card" style={{ borderRadius: "10px" }}>
                    <Card.Body>

                      <div className="d-flex justify-content-between">
                        <h6 className="fw-bold mb-0">{review.name}</h6>
                        <small className="text-muted">{review.date}</small>
                      </div>

                      <div className="mb-2">
                        {[...Array(review.rating)].map((_, i) => (
                          <FaStar key={i} color="gold" size={16} />
                        ))}
                      </div>

                      <p className="mb-0">{review.text}</p>

                    </Card.Body>
                  </Card>

                </motion.div>

              ))}

            </motion.div>

          </Col>

        </Row>
      </Container>
    </section>
  );
}

export default GoogleReviews;